import { email as isEmail } from 'redux-form-validators';

export const required = value => (value ? undefined : 'Required field');
export const email = (value = '') => (isEmail()(value) ? 'Invalid email address' : undefined);

export const composeValidators = (...validators) => (value, allValues) =>
  validators.reduce((error, validator) => error || validator(value, allValues), undefined);
